const url = '/languages';
const Provider = 'Languages';
const dbModel = 'Languages';

export { url, Provider, dbModel };
